module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.jpg.astc.9e38be3f.ktx";